export default __webpack_public_path__ + "static/media/Connection Error.eb148422.svg";